const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5040';

const handleResponse = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || 'Error en la solicitud');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
};

const withAuth = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

export const api = {
  get: (path, token) =>
    fetch(`${API_BASE}${path}`, { headers: withAuth(token) }).then(handleResponse),
  post: (path, body, token) =>
    fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...withAuth(token) },
      body: JSON.stringify(body),
    }).then(handleResponse),
  put: (path, body, token) =>
    fetch(`${API_BASE}${path}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...withAuth(token) },
      body: JSON.stringify(body),
    }).then(handleResponse),
  delete: (path, token) =>
    fetch(`${API_BASE}${path}`, { method: 'DELETE', headers: withAuth(token) }).then(handleResponse),
  uploadImage: (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    return fetch(`${API_BASE}/api/upload/image`, {
      method: 'POST',
      headers: {
        ...withAuth(token),
      },
      body: formData,
    }).then(handleResponse);
  },
};

export const endpoints = {
  auth: {
    login: () => '/api/auth/admin/login',
    register: () => '/api/auth/admin/register',
  },
  events: () => '/api/events',
  event: (id) => `/api/events/${id}`,
  eventActive: () => '/api/events/active',
  eventToggle: (id) => `/api/events/${id}/toggle-active`,
  users: () => '/api/users',
  user: (id) => `/api/users/${id}`,
  stations: () => '/api/stations',
  station: (id) => `/api/stations/${id}`,
  questions: () => '/api/questions',
  question: (id) => `/api/questions/${id}`,
  questionsByStation: (id) => `/api/questions/station/${id}`,
  agendas: () => '/api/agendas',
  agenda: (id) => `/api/agendas/${id}`,
  agendasByEvent: (id) => `/api/agendas/event/${id}`,
  topics: () => '/api/topics',
  topic: (id) => `/api/topics/${id}`,
  topicsByEvent: (id) => `/api/topics/event/${id}`,
  surveys: () => '/api/surveys',
  speakers: () => '/api/speakers',
  speaker: (id) => `/api/speakers/${id}`,
  speakersByEvent: (id) => `/api/speakers/event/${id}`,
  promotions: () => '/api/promotions',
  promotion: (id) => `/api/promotions/${id}`,
  promotionsByEvent: (id) => `/api/promotions/event/${id}`,
  configurations: (eventId) => `/api/configurations/${eventId}`,
  configurationsActive: () => '/api/configurations/active',
};
